<mat-toolbar class="mandatesbg">

    <div>
        <button mat-icon-button (click)="goBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <div class="title">
            <mat-icon [ngClass]="item.values | mandateIconColor">{{item.values.status | icon:'mandateStatus'}}
            </mat-icon>
            <ng-container *ngIf="!new">
                {{setting.prefixMandate + item.values.ref}}: {{item.values.exclusive ? 'Exclusive' : ''}}
                {{item.values.type | param:'mandateTypes'}} Mandate
                <ng-container *ngIf="item.values.price">: {{item.values.price | number}} {{item.values.cy |
                    param:'cies'}}{{item.values.type === 'rental' ? ' / month' : ''}}</ng-container>
            </ng-container>
            <ng-container *ngIf="new">New Mandate</ng-container>
        </div>
    </div>
    <div>
        <ng-container *ngIf="unit && unit.values && !unit.loading">
            {{unit.values.score ? (unit.values.score + '%') : 'Missing Parameters' }}
            <button mat-icon-button [matMenuTriggerFor]="alerts">
                <mat-icon
                    [ngClass]="{'hot': unit.values.score < 50, 'warm': unit.values.score >= 50 && unit.values.score < 80, 'active': unit.values.score >= 80}">{{unit.values.error
                    ? GLOBAL.ICONS.ALERT : GLOBAL.ICONS.MARKETING}}</mat-icon>

            </button>
            <mat-menu #alerts="matMenu">
                <button mat-menu-item *ngFor="let alert of unit.values.alerts">
                    <mat-icon color="warn" *ngIf="alert.type === 'error'">{{GLOBAL.ICONS.ERROR}}</mat-icon>
                    <mat-icon color="accent" *ngIf="alert.type === 'marketing'">{{GLOBAL.ICONS.MARKETING}}</mat-icon>
                    <span>{{alert.code | param:'alerts'}}</span>
                </button>
            </mat-menu>
        </ng-container>
        <profile></profile>
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <ng-container
                *ngIf="isOneOfRoles(['admin', 'director', 'assistant', 'marketing']) || (isOneOfRoles(['realtor']) && item.values.realtor === db.auth.uid)">
                <button mat-menu-item *ngIf="item.values.status !== 'deal' && item.values.status !== 'failed'"
                    (click)="handover()">
                    <mat-icon>{{GLOBAL.ICONS.HANDOVER}}</mat-icon>
                    <span>Swap Agent</span>
                </button>
                <button *ngIf="item.values.status === 'active'" mat-menu-item (click)="pause(true)">
                    <mat-icon>{{GLOBAL.ICONS.PAUSE}}</mat-icon>
                    <span>Pause</span>
                </button>
                <button *ngIf="item.values.status !== 'failed' && item.values.status !== 'deal'" mat-menu-item
                    (click)="failed()">
                    <mat-icon>{{GLOBAL.ICONS.FAILED}}</mat-icon>
                    <span>Failed</span>
                </button>
                <button *ngIf="item.values.status === 'failed' && isOneOfRoles(['admin', 'assistant', 'director'])"
                    mat-menu-item (click)="pause(false)">
                    <mat-icon class="active">{{GLOBAL.ICONS.ACTIVE}}</mat-icon>
                    <span>Active</span>
                </button>
                <button *ngIf="item.values.status === 'pause'" mat-menu-item (click)="pause(false)">
                    <mat-icon class="active">{{GLOBAL.ICONS.ACTIVE}}</mat-icon>
                    <span>Active</span>
                </button>
                <button [disabled]="item.values.matching" mat-menu-item (click)="forceMatching()">
                    <mat-icon>{{GLOBAL.ICONS.MATCHING}}</mat-icon>
                    <span>Force Matchings</span>
                </button>
                <button *ngIf="db.isOneOfRoles(['admin', 'director', 'assistant', 'marketing'])" mat-menu-item
                    color="primary" (click)="forceMandateSync()">
                    <mat-icon matListIcon>sync_problem</mat-icon>
                    <span>Force Portal Sync</span>
                </button>
            </ng-container>
            <button mat-menu-item (click)="logs()">
                <mat-icon>{{GLOBAL.ICONS.LOGS}}</mat-icon>
                <span>Logs</span>
            </button>
            <button mat-menu-item *ngIf="!new && !pageConfig.edit && isRole('admin')" (click)="db.deleteItem(item)">
                <mat-icon matListIcon>delete</mat-icon>
                <span>Delete Mandate!</span>
            </button>
        </mat-menu>
    </div>
</mat-toolbar>
<div class="toolbartop"></div>

<div class="mainPage">
    <img mat-card-avatar class="realtorPage" [src]="item.values.realtor | realtor"
        [matTooltip]="item.values.realtor | realtorName" *ngIf="db.auth.uid !== item.values.realtor" />
    <mat-tab-group [(selectedIndex)]="pageConfig.mainTab" (selectedTabChange)="tabChanged()">


        <!--------------------------------------------- OVERVIEW ----------------------------------------------------------->

        <mat-tab *ngIf="item.values.status !== 'new' && item.values.status !== 'pending'">
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon">{{GLOBAL.ICONS.DASHBOARD}}</mat-icon>&nbsp;
                Overview
            </ng-template>

            <div class="mdc-layout-grid">
                <div class="mdc-layout-grid__inner">
                    <div class="mdc-layout-grid__cell--span-3">
                        <mat-card class="backspace">
                            <mat-list>
                                <mat-list-item>
                                    <div matLine style="font-size: 35px;text-align: center;"
                                        [ngClass]="colorMandateDate()">
                                        {{tools.timeago(item.values.type === 'sale' ? item.values.dateStart :
                                        item.values.dateAvailable)}}</div>

                                </mat-list-item>
                            </mat-list>
                        </mat-card>
                        <app-mandate-edit [item]="item" [bckpValues]="bckpValues"></app-mandate-edit>
                        <app-agency-fee-mandate-edit [item]="item" [bckpValues]="bckpValues"
                            *ngIf="['payment', 'deal'].includes(item.values.status) && isOneOfRoles(['admin', 'accountant'])">
                        </app-agency-fee-mandate-edit>
                    </div>
                    <div class="mdc-layout-grid__cell--span-6">
                        <div class="mdc-layout-grid__inner">
                            <div class="mdc-layout-grid__cell--span-6">
                                <mat-card class="backspace cursor" (click)="moveTab(1)">
                                    <!-- ACTIONS -->
                                    <mat-list>
                                        <mat-list-item *ngFor="let action of pendingActions">
                                            <mat-icon matListIcon color="accent">{{action.icon}}</mat-icon>
                                            <div matLine>
                                                <b>{{action.type | param:'actionTypes'}}</b>
                                            </div>
                                            <div matLine>
                                                <i *ngIf="action.date">
                                                    {{action.date.toDate() | date:'dd MMM yyyy HH:mm'}}</i>
                                            </div>
                                        </mat-list-item>
                                        <mat-list-item *ngFor="let action of dashDisplayActions">
                                            <mat-icon matListIcon
                                                [color]="dashActions[action].nb ? 'primary' : ''">{{dashActions[action].icon}}</mat-icon>
                                            <div matLine>
                                                <b>{{dashActions[action].nb}} {{dashActions[action].label}}</b>
                                            </div>
                                            <div matLine>
                                                <i *ngIf="dashActions[action].timeago.length">
                                                    {{dashActions[action].timeago}}</i>
                                            </div>
                                        </mat-list-item>
                                    </mat-list>
                                </mat-card>

                                <!-- VISIT -->
                                <app-organise-visit-edit [item]="item" [bckpValues]="bckpValues">
                                </app-organise-visit-edit>

                            </div>
                            <div class="mdc-layout-grid__cell--span-6">
                                <!-- Display Stats -->
                                <mat-card class="backspace ">
                                    <mat-list>
                                        <mat-list-item *ngIf="matchNb.new" class="cursor" (click)="moveTab(3)">
                                            <mat-icon matListIcon color="warn">{{GLOBAL.ICONS.NEW}}</mat-icon>
                                            <div matLine style="font-size: 25px;text-align: center;">
                                                {{matchNb.new}} New Matchings</div>
                                        </mat-list-item>
                                        <mat-list-item class="cursor" (click)="moveTab(2)">
                                            <mat-icon matListIcon>{{GLOBAL.ICONS.MATCHING}}</mat-icon>
                                            <div matLine style="font-size: 25px;text-align: center;">
                                                {{matchNb.match}}/{{matchNb.total}} Matchings</div>
                                        </mat-list-item>
                                    </mat-list>
                                    <mat-list *ngIf="item.values.matching" style="position:relative">
                                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                    </mat-list>
                                </mat-card>
                                <!-- PORTALS -->
                                <app-advertise-edit *ngIf="showPortalDash && item.values.$key" [item]="item"
                                    [bckpValues]="bckpValues" [unitPortals]="unitPortals"></app-advertise-edit>
                            </div>
                        </div>
                    </div>
                    <div class="mdc-layout-grid__cell--span-3" *ngIf="unit && unit.values">
                        <app-unit-card [values]="item.values.synaps.unitMandatesObjList"
                            (click)="goItem('units', item.values.synaps.unitMandatesObj)" class="cursor">
                        </app-unit-card>
                        <ng-container *ngIf="unit.values.synaps?.ownersArray?.length; else noOwnersMandateOverview">
                            <div class="contact-accordion-wrap">
                                <mat-accordion class="contact-accordion" [multi]="false">
                                    <mat-expansion-panel *ngFor="let contact of unit.values.synaps.ownersArray; let i = index"
                                        [expanded]="i === 0">
                                        <mat-expansion-panel-header>
                                            <mat-icon class="example-tab-icon">{{GLOBAL.ICONS.CONTACT}}</mat-icon>
                                            <span>{{contact.fullname}}</span>
                                        </mat-expansion-panel-header>
                                        <app-contact-tab [key]="contact.$key"
                                            [options]="{link:true, noCard:true, hideFullname:true, backLinkKey:unit.values.$key, backLinkModel: 'units'}">
                                        </app-contact-tab>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </ng-container>
                        <ng-template #noOwnersMandateOverview>
                            <div class="contact-accordion-empty">
                                <div class="contact-accordion-empty-content">
                                    <mat-icon class="contact-accordion-alert-icon">{{GLOBAL.ICONS.CONTACT}}</mat-icon>
                                    <span class="contact-accordion-alert">Alert: No contact selected.</span>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

        </mat-tab>


        <!--------------------------------------------- ACTIONS ----------------------------------------------------------->

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon">{{GLOBAL.ICONS.ACTIONS}}</mat-icon>&nbsp;
                Tasks
            </ng-template>

            <div class="container split s25">
                <div class="main">
                    <div class="action" *ngFor="let action of actionService?.items">
                        <div class="date">
                            <div class="txt">
                                {{action.date?.toDate() | date:'dd MMM yy'}}<br />
                                {{action.date?.toDate() | date:'HH:mm'}}
                            </div>
                            <div class="actionRealtor">
                                <button mat-mini-fab [color]="action.done ? 'primary' : 'accent'"
                                    (click)="copyClipboard(action.$key)" style="cursor:none">
                                    <mat-icon>{{action.icon}}</mat-icon>
                                </button>
                                <img mat-card-avatar [src]="action.realtor | realtor"
                                    [matTooltip]="action.realtor | realtorName" (click)="copyClipboard(action.$key)" />
                            </div>
                        </div>
                        <div class="panel">
                            <mat-spinner [strokeWidth]="3" [diameter]="70" *ngIf="action.creating"></mat-spinner>
                            <action-select *ngIf="!action.creating" [action]="action" [moduleItem]="item"
                                [allMatchings]="matching.items" (selectDoneFn)="actionDone($event)"></action-select>
                        </div>
                    </div>
                </div>
                <div class="side">
                    <ng-container *ngIf="unit && unit.values">
                        <ng-container *ngIf="unit.values.synaps?.ownersArray?.length; else noOwnersMandateSide">
                            <div class="contact-accordion-wrap">
                                <mat-accordion class="contact-accordion" [multi]="false">
                                    <mat-expansion-panel *ngFor="let contact of unit.values.synaps.ownersArray; let i = index"
                                        [expanded]="i === 0">
                                        <mat-expansion-panel-header>
                                            <mat-icon class="example-tab-icon">{{GLOBAL.ICONS.CONTACT}}</mat-icon>
                                            <span>{{contact.fullname}}</span>
                                        </mat-expansion-panel-header>
                                        <app-contact-tab [key]="contact.$key"
                                            [options]="{link:true, noCard:true, hideFullname:true, backLinkKey:unit.values.$key, backLinkModel: 'units'}">
                                        </app-contact-tab>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </ng-container>
                        <ng-template #noOwnersMandateSide>
                            <div class="contact-accordion-empty">
                                <div class="contact-accordion-empty-content">
                                    <mat-icon class="contact-accordion-alert-icon">{{GLOBAL.ICONS.CONTACT}}</mat-icon>
                                    <span class="contact-accordion-alert">Alert: No contact selected.</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                    <app-unit-card *ngIf="item.values.synaps?.unitMandatesObjList"
                        [values]="item.values.synaps.unitMandatesObjList"
                        (click)="goItem('units', item.values.synaps.unitMandatesObj)" class="cursor">
                    </app-unit-card>
                </div>
            </div>

        </mat-tab>


        <!--------------------------------- MATCHING DETAILS ------------------------------------------------------>


        <mat-tab *ngIf="item.values.status !== 'new' && item.values.status !== 'pending'">
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon">{{GLOBAL.ICONS.MATCHING}}</mat-icon>&nbsp;
                {{matchNb.match}}/{{matchNb.total}} Matchings
            </ng-template>
            <project-matchings [mandate]="item" [matching]="matching" [status]="item.values.status"
                [matchOnly]="matchOnly">
            </project-matchings>
        </mat-tab>
        <mat-tab *ngIf="matchNb.new">
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon" color="warn">{{GLOBAL.ICONS.NEW}}</mat-icon>&nbsp;
                {{matchNb.new}} New Matchings
            </ng-template>
            <new-project-matchings [mandate]="item" [matching]="matching"
                (doneFn)="backToMatching()"></new-project-matchings>
        </mat-tab>

        <!-- <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon"
                    [ngClass]="{active:item.values.ad}">{{GLOBAL.ICONS.MARKETING}}</mat-icon>&nbsp;
                Portals
            </ng-template>
            <app-advertise-edit *ngIf="showPortalDash && item.values.$key" [item]="item" [bckpValues]="bckpValues"
                [unitPortals]="unitPortals"></app-advertise-edit>
        </mat-tab> -->

    </mat-tab-group>

    <button *ngIf="item.values.status === 'new'" mat-fab color="primary" class="bottom-right pfixed"
        (click)="acceptMandate()">
        <mat-icon matListIcon>thumb_up</mat-icon>
    </button>

    <app-speed-dial-fab *ngIf="isRealtor() && item.values.status !== 'new'" [fabButtons]="actionButtons"
        (clickFn)="createActionMenu($event)">
    </app-speed-dial-fab>

</div>


<mat-spinner [strokeWidth]="5" class="fixed" *ngIf="!(pageConfig.loaded || new)"></mat-spinner>